import React from 'react';
import { Translation } from "react-i18next";
import PropTypes from 'prop-types';
import { SITE_URL } from 'utils/restapi';
import AuthenticationButton from 'components/elements/buttons/AuthenticationButton';

const CLIENT_ID = '266003681172790';
const CALLBACK_URL = `${SITE_URL}/login/facebook`;

const FacebookButton = ({ verb }) => (
  <Translation>
    {(t) => (
      <AuthenticationButton
        type='facebook'
        href={`https://www.facebook.com/v11.0/dialog/oauth?client_id=${CLIENT_ID}&redirect_uri=${CALLBACK_URL}&state=fbloginheylinkme&scope=email`}
      >
        {verb} {t("with")} <b>Facebook</b>
      </AuthenticationButton>
    )}
  </Translation>
);

FacebookButton.propTypes = {
  verb: PropTypes.string,
};
FacebookButton.defaultProps = {
  verb: 'Log in',
};

export default FacebookButton;
